import type { ShellSlice } from '../bs/shell'

/**
 * Serbian overrides for the application frame.
 *
 * The jat reflex, mostly: *promijeni* → *promeni*, *svijetla* → *svetla*,
 * *sljedeće* → *sledeće*, *obavještenja* → *obaveštenja*, *dodijele* →
 * *dodele*, *ovdje* → *ovde*, *biće poslate* stays but *poslata* does not.
 *
 * The plural keys are absent: the three-form rule is the same and so is the
 * declension of *prijava*, so overriding them would repeat the base.
 */
export const shell: Partial<ShellSlice> = {
  'brand.illustrationAlt': 'Skeniranje QR nalepnice na opremi u pogonu',

  'language.change': 'Promeni jezik',

  'theme.light': 'Svetla tema',
  'theme.tooltip': '{current} · sledeće: {next}',

  'nav.tasks.hint': 'Zadaci dodeljeni vama',

  /*
   * The new frame's strings: the jat again, and *da* + present where Bosnian
   * takes an infinitive ("Šta želite da započnete?").
   */
  'quick.sheetTitle': 'Šta želite da započnete?',
  'quick.submission.hint': 'Kvar, opasnost ili predlog',
  'quick.walk.hint': 'Ocenite red na radnom mestu',
  'quick.task.hint': 'Dodelite posao uz otvorenu prijavu',
  'crumb.label': 'Gde se nalazite',
  'search.emptyHint': 'Probajte broj prijave, šifru mašine ili deo naslova.',
  'search.unavailable':
    'Pretraga prijava i mašina trenutno ne radi. Stranice i akcije su i dalje ovde.',
  'search.action.notifications': 'Moja obaveštenja',
  'search.action.notificationSettings': 'Postavke obaveštenja',
  'search.keywords.submission': 'prijavi kvar problem opasnost ideja predlog',
  'search.keywords.walk': 'ocena evaluacija red čistoća',
  'search.keywords.task': 'zadatak dodeli posao',
  'search.keywords.notifications': 'obaveštenja zvono',
  'search.keywords.notificationSettings': 'e-pošta email mail sažetak obaveštenja',
  'search.keywords.scan': 'qr kod nalepnica kamera',

  'boot.checkingSession': 'Provera sesije',

  'notifications.title': 'Obaveštenja',
  'notifications.empty': 'Nema obaveštenja',
  'notifications.emptyHint':
    'Ovde stižu zadaci koji vam se dodele i promene na vašim prijavama.',

  /*
   * `queue.offlineNotice` is deliberately absent. It is a long sentence with no
   * jat anywhere in it — "Prijave su sačuvane na uređaju i biće poslate…" is
   * already correct ekavica — so an override would be sixty words repeating the
   * base, and the test that forbids that is right to.
   */
  'queue.hint': 'Prijave se šalju automatski. Ovde možete proveriti šta je ostalo.',

  'module.disabled.description':
    '„{module}“ trenutno nije deo vaše aplikacije. Podaci su sačuvani — ako vam ovaj deo treba, obratite se svom administratoru.',

  // *dodeljen*, *dodeli*, *ovde*.
  'plants.none.title': 'Nemate dodeljen nijedan pogon — obratite se administratoru',
  'plants.none.body':
    'Prijave, zadaci, 5S i analitika prikazuju se po pogonima, a vama još nijedan nije dodeljen. Čim vam ga administrator dodeli, ovde se pojavi sve iz njega.',
  'plants.none.retry': 'Proveri ponovo',
}
